import { Component, Input, input } from '@angular/core';
import { SpinnerComponent } from '../spinner/spinner.component';
import { NgClass, NgStyle } from '@angular/common';
import { IconNames } from '@app/shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

export type IconInfo = { iconName: IconNames; size: string };
@Component({
  selector: 'app-ice-button',
  templateUrl: './ice-button.component.html',
  styleUrls: ['./ice-button.component.scss'],
  imports: [NgClass, NgStyle, SpinnerComponent, MatTooltip, MatIcon],
})
export class IceButtonComponent {
  @Input() id: string = '';
  @Input() color: 'primary' | 'outlined' | 'secondary' | 'underline' | 'tertiary' = 'primary';
  @Input() size: 'extra-small' | 'small' | 'medium' | 'large' = 'large';
  @Input() type: 'button' | 'menu' | 'submit' | 'reset' = 'button';
  @Input() icon: IconInfo;
  @Input() width: string = 'auto';
  @Input() disabled: boolean = false;
  @Input() isLoading = false;
  @Input() tab: string = '0';
  @Input() height: string;
  @Input() tooltip: string;
  testId = input.required<string>();
}
